const actions = {
  CREATE_USER_BEGIN: "CREATE_USER_BEGIN",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_ERR: "CREATE_USER_ERR",

  LIST_USERS_BEGIN: "LIST_USERS_BEGIN",
  LIST_USERS_SUCCESS: "LIST_USERS_SUCCESS",
  LIST_USERS_ERR: "LIST_USERS_ERR",

  UPDATE_USER_BEGIN: "UPDATE_USER_BEGIN",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_ERR: "UPDATE_USER_ERR",

  DELETE_USER_BEGIN: "DELETE_USER_BEGIN",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_ERR: "DELETE_USER_ERR",

  BLOCK_USER_BEGIN: "BLOCK_USER_BEGIN",
  BLOCK_USER_SUCCESS: "BLOCK_USER_SUCCESS",
  BLOCK_USER_ERR: "BLOCK_USER_ERR",

  UNBLOCK_USER_BEGIN: "UNBLOCK_USER_BEGIN",
  UNBLOCK_USER_SUCCESS: "UNBLOCK_USER_SUCCESS",
  UNBLOCK_USER_ERR: "UNBLOCK_USER_ERR",

  GET_USER_DETAILS_BEGIN: "GET_USER_DETAILS_BEGIN",
  GET_USER_DETAILS_SUCCESS: "GET_USER_DETAILS_SUCCESS",
  GET_USER_DETAILS_ERR: "GET_USER_DETAILS_ERR",

  createUserBegin: () => {
    return {
      type: actions.CREATE_USER_BEGIN,
    };
  },

  createUserSuccess: (data) => {
    return {
      type: actions.CREATE_USER_SUCCESS,
      data,
    };
  },

  createUserErr: (err) => {
    return {
      type: actions.CREATE_USER_ERR,
      err,
    };
  },

  listUsersBegin: () => {
    return {
      type: actions.LIST_USERS_BEGIN,
    };
  },

  listUsersSuccess: (data) => {
    return {
      type: actions.LIST_USERS_SUCCESS,
      data,
    };
  },

  listUsersErr: (err) => {
    return {
      type: actions.LIST_USERS_ERR,
      err,
    };
  },

  updateUserBegin: () => {
    return {
      type: actions.UPDATE_USER_BEGIN,
    };
  },

  updateUserSuccess: (data) => {
    return {
      type: actions.UPDATE_USER_SUCCESS,
      data,
    };
  },

  updateUserErr: (err) => {
    return {
      type: actions.UPDATE_USER_ERR,
      err,
    };
  },

  deleteUserBegin: () => {
    return {
      type: actions.DELETE_USER_BEGIN,
    };
  },

  deleteUserSuccess: (data) => {
    return {
      type: actions.DELETE_USER_SUCCESS,
      data,
    };
  },

  deleteUserErr: (err) => {
    return {
      type: actions.DELETE_USER_ERR,
      err,
    };
  },

  blockUserBegin: () => {
    return {
      type: actions.BLOCK_USER_BEGIN,
    };
  },

  blockUserSuccess: (data) => {
    return {
      type: actions.BLOCK_USER_SUCCESS,
      data,
    };
  },

  blockUserErr: (err) => {
    return {
      type: actions.BLOCK_USER_ERR,
      err,
    };
  },

  unblockUserBegin: () => {
    return {
      type: actions.UNBLOCK_USER_BEGIN,
    };
  },

  unblockUserSuccess: (data) => {
    return {
      type: actions.UNBLOCK_USER_SUCCESS,
      data,
    };
  },

  unblockUserErr: (err) => {
    return {
      type: actions.UNBLOCK_USER_ERR,
      err,
    };
  },

  getUserDetailsBegin: () => {
    return {
      type: actions.GET_USER_DETAILS_BEGIN,
    };
  },

  getUserDetailsSuccess: (data) => {
    return {
      type: actions.GET_USER_DETAILS_SUCCESS,
      data,
    };
  },

  getUserDetailsErr: (err) => {
    return {
      type: actions.GET_USER_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
